// =====================================================
// CLASIFICACIÓN CONTABLE - Constantes compartidas
// =====================================================

// Cuentas del Estado de Resultados para clasificar gastos
export const CUENTAS_ER = [
  // Costos Fijos
  { value: "oficina", label: "Oficina", grupo: "Costos Fijos" },
  { value: "transporte", label: "Transporte", grupo: "Costos Fijos" },
  { value: "telefonia", label: "Telefonía", grupo: "Costos Fijos" },
  { value: "marketing", label: "Marketing", grupo: "Costos Fijos" },
  { value: "contador", label: "Contador", grupo: "Costos Fijos" },
  { value: "abogados", label: "Abogados", grupo: "Costos Fijos" },
  { value: "gastos_representacion", label: "Gastos representación", grupo: "Costos Fijos" },
  { value: "asesoria_externa", label: "Asesoría externa", grupo: "Costos Fijos" },
  { value: "alojamiento", label: "Alojamiento", grupo: "Costos Fijos" },
  { value: "viajes_gerencia", label: "Viajes Gerencia", grupo: "Costos Fijos" },
  { value: "gastos_bancarios", label: "Gastos Financieros", grupo: "Costos Fijos" },
  { value: "rrhh", label: "RRHH", grupo: "Costos Fijos" },
  { value: "pago_impuesto", label: "Impuestos", grupo: "Costos Fijos" },
  { value: "servicios_online", label: "Servicios Online", grupo: "Costos Fijos" },
  { value: "contenidos_digitales", label: "Contenidos Digitales", grupo: "Costos Fijos" },
  { value: "varios", label: "Varios", grupo: "Costos Fijos" },
  // Costos Variables
  { value: "hardware", label: "Hardware", grupo: "Costos Variables" },
  { value: "software_ds", label: "Software DS", grupo: "Costos Variables" },
  { value: "mantenimiento", label: "Mantenimiento", grupo: "Costos Variables" },
  { value: "servicios_internet", label: "Servicios Internet", grupo: "Costos Variables" },
];

// Tipos de activo (extraídos de GestionActivos)
export const TIPOS_ACTIVO = [
  { value: "accesorios", label: "Accesorios", vidaUtil: 60, esIntangible: false },
  { value: "antena", label: "Antena", vidaUtil: 60, esIntangible: false },
  { value: "computador", label: "Computador", vidaUtil: 36, esIntangible: false },
  { value: "costo_instalacion", label: "Costo instalación", vidaUtil: 60, esIntangible: false },
  { value: "herramientas", label: "Herramientas", vidaUtil: 60, esIntangible: false },
  { value: "insumos_instalacion", label: "Insumos instalación", vidaUtil: 60, esIntangible: false },
  { value: "investigacion", label: "Investigación", vidaUtil: 24, esIntangible: true },
  { value: "licencia", label: "Licencia", vidaUtil: 36, esIntangible: true },
  { value: "marca", label: "Marca", vidaUtil: 120, esIntangible: true },
  { value: "pantalla", label: "Pantalla", vidaUtil: 60, esIntangible: false },
  { value: "patente", label: "Patente", vidaUtil: 120, esIntangible: true },
  { value: "reproductor", label: "Reproductor", vidaUtil: 60, esIntangible: false },
  { value: "smartphone", label: "Smartphone", vidaUtil: 24, esIntangible: false },
  { value: "software", label: "Software", vidaUtil: 36, esIntangible: true },
  { value: "soporte", label: "Soporte", vidaUtil: 60, esIntangible: false },
  { value: "totem", label: "Tótem", vidaUtil: 60, esIntangible: false },
  { value: "vestimenta", label: "Vestimenta", vidaUtil: 24, esIntangible: false },
];

// Tipos que se serializan 1-fila-por-unidad (equipos con serie de fábrica e identidad
// propia). Todo lo que NO esté acá — consumibles (insumos, herramientas), partes pasivas
// (soportes) y servicios (costo_instalacion) — va como 1 sola fila con `cantidad`.
// Motivo: explotar consumibles generaría cientos de filas sin valor (p.ej. 965 unidades de
// insumos_instalacion hoy), y un servicio no tiene unidad física que serializar.
// Ver bloque Stock (ARQUITECTURA 9.36). Los values coinciden con TIPOS_ACTIVO.
export const TIPOS_SERIALIZABLES = ["pantalla", "reproductor", "totem", "antena", "computador", "smartphone"];

export const esSerializablePorTipo = (tipo) => TIPOS_SERIALIZABLES.includes(tipo);

// Destinos posibles para activos
export const DESTINO_TIPOS = [
  { value: "", label: "Sin asignar" },
  { value: "edificio", label: "Edificio" },
  { value: "carteleria", label: "Proyecto cartelería" },
  { value: "empleado", label: "Empleado" },
];

// Helpers
export const getVidaUtilPorTipo = (tipo) => {
  const found = TIPOS_ACTIVO.find((t) => t.value === tipo);
  return found ? found.vidaUtil : 60;
};

export const esIntangiblePorTipo = (tipo) => {
  const found = TIPOS_ACTIVO.find((t) => t.value === tipo);
  return found ? found.esIntangible : false;
};
